module.exports = __webpack_public_path__ + "static/media/Virtual-mirror-lens-4-psd_Fresh-ROSE.1b2bc9a9.png";